import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from "@sentry/react";
import App from './App';
import './index.css';

// Initialize Sentry BEFORE anything else
Sentry.init({
  dsn: "https://d9ca0edcd945abf778156599a826dc6f@o4509445701959680.ingest.us.sentry.io/4509445742198784",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, // 10% of transactions for performance monitoring
  // Control which URLs get distributed tracing
  tracePropagationTargets: [
    "localhost", 
    /^https:\/\/.*\.supabase\.co/, // Your Supabase backend
    "https://accounts.google.com", // Google OAuth endpoints
  ],
  // Environment detection
  environment: process.env.NODE_ENV,
  // Optional: Don't send events in development to keep data clean
  beforeSend(event) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Sentry event (dev mode):', event);
      return null; // Don't send to Sentry in development
    }
    return event;
  },
});

// You'll need to replace this with your actual Google Client ID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your-google-client-id';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
); 